<script setup lang="ts">
  import Hero from '@/domains/investor/components/Hero/Hero.vue'
  import type { IProps } from './Hero.types'

  const localePath = useLocalePath()
  const pathToPage = localePath('for-investors-corporate-governance-management-board')

  defineProps<IProps>()
</script>

<template>
  <Hero
    :title="title"
    :lead="lead"
    :image="image"
    :second-category="{
      label: title,
      url:  $t('investor.corporateGovernance.member.hero.secondCategory.url'),
      aria:  $t('investor.corporateGovernance.member.hero.secondCategory.aria', { member: title})
    }"
    :main-category="{
      label: $t('investor.corporateGovernance.member.hero.mainCategory.label'),
      url:  pathToPage,
      aria: $t('investor.corporateGovernance.member.hero.mainCategory.aria')
    }"
    :first-button="{
      text: $t('investor.corporateGovernance.member.hero.firstButton.label'),
      to: $t('investor.corporateGovernance.member.hero.secondCategory.url'),
    }"
  />
</template>
